import Icons, { SvgIconProps } from '../Icons';

export default function (props: SvgIconProps) {
  return (
    <Icons {...props}>
      <path d="M16.0586 8.00671C15.2556 7.47976 14.6759 6.63697 14.4952 5.65444C14.4561 5.44205 14.4347 5.22366 14.4347 5H11.8717L11.8675 15.3353C11.8244 16.4926 10.8779 17.4216 9.71723 17.4216C9.35656 17.4216 9.01681 17.3309 8.71788 17.1724C8.03215 16.8092 7.56296 16.0859 7.56296 15.2536C7.56296 14.0582 8.52946 13.0857 9.71723 13.0857C9.939 13.0857 10.1516 13.1225 10.3529 13.1859V11.1639V10.5531C10.1446 10.5245 9.93303 10.5068 9.71723 10.5068C7.11618 10.5068 5 12.6361 5 15.2534C5 16.8593 5.79749 18.2804 7.01388 19.1397C7.78001 19.6809 8.71215 20 9.71723 20C12.3183 20 14.4345 17.8706 14.4345 15.2534V10.0129C15.4395 10.7389 16.6711 11.1667 18 11.1667V9.16231V8.58777C17.2844 8.58777 16.6176 8.37363 16.0586 8.00671Z" />
    </Icons>
  );
}
